module.exports = __webpack_public_path__ + "img/yz_game_commentDetails_smile.2a280639.png";